import type { Route } from 'nextjs-routes';

type OGPageType = 'Home Page' | 'Root page' | 'Regular page';

const OG_TYPE_DICT: Record<Route['pathname'], OGPageType> = {
  '/': 'Home Page',
  '/vaults': 'Regular page',
  '/vaults/[id]': 'Regular page',
  '/press-kit': 'Regular page',
  '/404': 'Home Page',
  '/api/deposit/verify/[address]': 'Regular page',
  '/t-debug': 'Regular page',
  '/directional-vaults': 'Regular page',
  '/directional-vaults/positions': 'Regular page',
  '/api/deposit/tokens': 'Regular page',
  '/api/proxy/drv/[...path]': 'Regular page',
  '/api/tokens': 'Regular page',
  '/sass-example': 'Regular page',
  '/sofa-example': 'Regular page',
  '/test-bridge': 'Regular page',
  '/api/wormhole': 'Regular page',
  '/directional-vaults/automator': 'Regular page',
  '/wormhole': 'Regular page',
};

export default function getPageOgType(pathname: Route['pathname']) {
  return OG_TYPE_DICT[pathname];
}
